const apiUrl = process.env.REACT_APP_API_URL;
export const DeleteJutgeProblemaIdTestId = async (id_problema: string, id_test: string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/problemes/${id_problema}/tests/${id_test}`,
            {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
